import type { BadgeProps } from '@chakra-ui/react'
import { Badge } from '@chakra-ui/react'
import { useTranslationsContext } from 'BrokerTsLib/src/context/TranslationsContext'

export interface SelectedBadgeProps extends BadgeProps {
  text?: string | React.ReactNode
}

export const SelectedBadge = ({ sx, text, ...rest }: SelectedBadgeProps) => {
  const { translate } = useTranslationsContext()
  return (
    <Badge
      colorScheme="green"
      variant="solid"
      sx={{
        ...sx,
        zIndex: '1' // pridano kvuli prekryti loading boxem
      }}
      {...rest}
    >
      {text && text}
      {!text && translate('selected', 'Vybraná')}
    </Badge>
  )
}
